<template>
    <div class="car-quote-step passed-insurance">
        <quote-step-header
            :key="currentSubStep"
            :currentStep="currentSubStep + 1"
            :subtitle="subStepFields.subtitle"
            :title="subStepFields.title"
            :totalSteps="step.totalSteps"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-row flex center start">
                <div class="row-item">
                    <app-label>
                        {{ trans(`last_3_years_${this.coverageType}`) }}

                    </app-label>

                    <div class="form-group">
                        <app-text-radio-buttons
                            v-model="form[stepName].passedInsuranceCount"
                            :items="passedInsurance"
                            :message="errors.get('passedInsuranceCount')"
                            rounded-small
                        >
                        </app-text-radio-buttons>
                    </div>

                    <template v-if="form[stepName].passedInsuranceCount > 0">
                        <app-label
                        >{{
                                trans("have_3_years_past_claims").replace(
                                    ":years",
                                    form[stepName].passedInsuranceCount
                                )
                            }}
                        </app-label>

                        <div class="form-group">
                            <app-text-radio-buttons
                                v-model="
                                    form[stepName].haveLastThreeYearsClaims
                                "
                                :items="threeYearsClaims"
                                :message="
                                    errors.get('haveLastThreeYearsClaims')
                                "
                            >
                            </app-text-radio-buttons>
                        </div>
                    </template>
                </div>

                <div class="row-item">
                    <template
                        v-if="
                            form[stepName].passedInsuranceCount > 0 &&
                                form[stepName].haveLastThreeYearsClaims
                        "
                    >
                        <template
                            v-for="index in form[stepName].passedInsuranceCount"
                        >
                            <app-label>{{
                                    trans(`claims_${index}_year`)
                                }}
                            </app-label>

                            <div class="form-group">
                                <app-text-radio-buttons
                                    v-model="
                                        form[stepName][claimsYearKey(index)]
                                            .claimsAmount
                                    "
                                    :items="passedInsurance"
                                    :message="
                                        errors.get('passedInsuranceCount')
                                    "
                                    rounded-small
                                >
                                </app-text-radio-buttons>
                            </div>
                        </template>
                    </template>


                    <div class="start">

                    </div>
                </div>

                <div class="row-item">
                    <div class="second_header">
                        <p class="second_header--title">
                            {{ trans("second_title") }}
                        </p>

                        <p class="second_header--subtitle">
                            {{ trans("second_subtitle") }}
                        </p>
                    </div>
                </div>

                <div class="row-item">
                    <app-label>
                        {{ trans("has_3_year_body_claims") }}
                    </app-label>

                    <div class="form-group">
                        <app-text-radio-buttons
                            v-model="form[stepName].bodyClaimsAmount"
                            :breakMobile="true"
                            :items="bodyClaims"
                            :message="errors.get('bodyClaimsAmount')"
                            rounded-small
                        >
                        </app-text-radio-buttons>
                    </div>
                </div>

                <div class="row-item">
                    <app-label>
                        {{ trans("has_3_year_revoking") }}
                    </app-label>

                    <div class="form-group">
                        <app-text-radio-buttons
                            v-model="form[stepName]['revoking']"
                            :breakMobile="true"
                            :items="carRevoking"
                            :message="errors.get('revoking')"
                            rounded-small
                        >
                        </app-text-radio-buttons>
                    </div>
                </div>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";

export default {
    name: "CarQuotePassedInsurance",

    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"]
        };
    },

    mounted() {
        this.step.totalSteps = 2;
        this.handleInsuranceClaimsAndType();
    },

    methods: {
        claimsYearKey(year) {
            switch (year) {
                case 1:
                    return "oneYear";
                case 2:
                    return "twoYear";
                case 3:
                    return "threeYear";
                default:
                    return "oneYear";
            }

        },
        handleInsuranceClaimsAndType() {
            const passedInsuranceCount = this.form[this.stepName][
                "passedInsuranceCount"
                ];

            for (let i = 1; i <= 3; i++) {
                if (passedInsuranceCount < i) {
                    this.form[this.stepName][
                        this.claimsYearKey(i)
                        ].insuranceType = "none";
                    continue;
                }

                // this.form[this.stepName][
                //     this.claimsYearKey(i)
                // ].insuranceType = this.form["CarQuoteSelectCoverage"][
                //     "optional"
                // ];
            }
        }
    },

    watch: {
        form: {
            deep: true,
            handler() {
                this.handleInsuranceClaimsAndType();
            }
        }
    },

    computed: {

        coverageType() {
            return this.form[this.constants.CAR_COVERAGE_STEP].optional;
        },
        passedInsurance() {
            return [
                {
                    label: 0,
                    value: 0
                },
                {
                    label: 1,
                    value: 1
                },
                {
                    label: 2,
                    value: 2
                },
                {
                    label: "3+",
                    value: 3
                }
            ];
        },
        bodyClaims() {
            return [
                {
                    label: this.$trans("quote.car.revoking.no_claims"),
                    value: 0
                },
                {
                    label: 1,
                    value: 1
                },
                {
                    label: "2+",
                    value: 2
                }
            ];
        },
        carRevoking() {
            return [
                {
                    label: this.$trans("quote.car.revoking.no_revocations"),
                    value: 0
                },
                {
                    label: 1,
                    value: 1
                },
                {
                    label: "2+",
                    value: 2
                }
            ];
        },
        threeYearsClaims() {
            return [
                {
                    label: this.$trans("quote.car.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: false
                }
            ];
        },
        revoking() {
            return [
                {
                    label: this.$trans("quote.car.revoking.no"),
                    value: this.constants.REVOKING_NONE
                },
                {
                    label: this.$trans("quote.car.revoking.first"),
                    value: this.constants.REVOKING_1
                },
                {
                    label: this.$trans("quote.car.revoking.second"),
                    value: this.constants.REVOKING_2_MORE
                }
            ];
        },
        canMoveNext() {
            return true;
        }
    }
};
</script>

<style lang="scss">
.passed-insurance {
    width: 100%;
    max-width: $desktop;
}

.car-safety-check-wrap {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-bottom: 35px;
}

.second_header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .second_header--title {
        color: $black;
        text-align: center;
        font-size: $font-size-desktop;
        font-weight: $font-bold;
    }

    .second_header--subtitle {
        color: rgba(0, 0, 0, 0.5);
        text-align: center;
        font-size: 25px;
        font-weight: $font-normal;
    }
}

.history-items-wrap {
    position: relative;
    // margin-top: -30px;

    @media screen and (max-width: $mobile) {
        margin-top: 0;
        width: 100%;
    }

    .no-insurance-history {
        margin-bottom: -45px;

        @media screen and (max-width: $mobile) {
            margin-bottom: 0;
        }
    }

    .history-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        flex-wrap: wrap;

        &.disabled {
            pointer-events: none;
            opacity: 0.5;
        }

        .history-label {
            font-weight: bold;
            margin-left: 10px;
            min-width: 140px;

            @media screen and (max-width: $mobile) {
                flex: 0 100%;
                min-width: auto;
                margin-left: 0;
                margin-bottom: 20px;
            }
        }

        .history-item-inner {
            margin-left: 45px;

            @media screen and (max-width: $mobile) {
                flex: 0 50%;
                margin-left: 0;
            }

            &:last-child {
                margin: 0;
            }
        }

        .app-input-select {
            height: 40px;
            width: 100px !important;

            select {
                font-size: 19px;
            }
        }

        .app-box-input {
            .box-input-wrap {
                height: 40px;
                width: 80px !important;

                input {
                    font-size: 19px;
                    text-align: right;
                }
            }
        }
    }
}

.past-insurance-claims {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: -30px;

    .past-insurance-noclaims {
        font-weight: $font-light;
        font-size: 21px;
        margin-top: 40px;

        @media all and (max-width: $mobile) {
            font-size: 18px;
            font-weight: $font-light;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.28;
            letter-spacing: normal;
            text-align: center;
        }
    }
}
</style>
